import * as React from 'react';
export const arrowUpSvg = React.forwardRef(function arrowUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 0c.199 0 .39.08.53.22l3 3a.75.75 0 0 1-1.06 1.06L4.75 2.56v4.674a.75.75 0 0 1-1.5 0V2.561L1.53 4.28A.75.75 0 0 1 .47 3.22l3-3 .114-.094A.75.75 0 0 1 4 0Z',
    }),
  );
});
arrowUpSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowUp = {
  category: 'icon',
  colorable: true,
  name: 'arrowUp',
  svg: arrowUpSvg,
};
